<template>
  <div class="card card-custom">
    <v-overlay :value="carregando" :absolute="true">
      <v-progress-circular indeterminate size="32" color="#462181" width="2"
        ><v-progress-circular
          indeterminate
          size="24"
          color="#ff7f00"
          width="2"
          rotate="180"
        ></v-progress-circular
      ></v-progress-circular>
    </v-overlay>

    <div class="card-body p-0 d-flex flex-column">
      <div
        class="d-flex align-items-center justify-content-between card-spacer"
      >
        <div class="d-flex align-items-center">
          <span class="card-titulo-icone mr-3"
            ><i class="fas fa-trophy"></i
          ></span>
          <h5 class="m-0 mr-3 card-titulo">Ranking Elos Duradouros</h5>
          <Tooltip
            message="A empresa receberá um prêmio que corresponder ao ranking que representar a sua melhor colocação"
          />
        </div>
        <div class="d-flex align-items-center" style="position: relative">
          <b-button
            variant="success"
            size="sm"
            class="ml-2"
            style="
              background: #472282 !important;
              border-color: #472282 !important;
            "
            @click="toggle"
            ref="BotaoMenu"
          >
            {{ label_botao_menu }}
          </b-button>
          <Menu
            ref="menu_togglable"
            id="overlay_menu"
            :model="timeline_filter_options()"
            style="
              position: absolute;
              transform: translateY(38px);
              z-index: 99;
              right: 0;
            "
            v-if="visible_menu_opcoes"
          />
        </div>
      </div>

      <div class="px-6 pb-6" v-if="carregando">
        <b-skeleton
          v-for="n in 4"
          :key="n"
          animation="wave"
          width="100%"
          height="44px"
          class="mb-2"
        ></b-skeleton>
      </div>

      <template v-else>
        <!-- WEL-5194: pódio (2º, 1º, 3º) — o 1º fica ao centro, mais alto. -->
        <div class="podio px-6">
          <div
            v-for="dado in podio"
            :key="dado.posicao"
            class="podio__lugar"
            :class="[
              nivelClasse(dado.posicao),
              { 'podio__lugar--propria': 'conta_id' in dado }
            ]"
          >
            <i
              :class="['fas', nivelIcone(dado.posicao), 'podio__icone']"
              v-b-tooltip.noninteractive.hover
              :title="'conta_id' in dado ? dado.conta_nome : ''"
            ></i>
            <div class="podio__degrau">
              <span class="podio__posicao">{{ dado.posicao }}º</span>
              <span class="podio__pontos"
                >{{ dado.pontuacao | formatacaoNumero }} pts</span
              >
            </div>
          </div>
        </div>

        <div class="px-6 pb-6">
          <!-- No pódio o destaque no degrau é sutil, então reforça com uma
          mensagem de parabéns. Fora do pódio, mostra a posição da conta. -->
          <div v-if="estaNoTop3" class="ranking-elos__parabens">
            <i class="fas fa-face-grin-stars"></i>
            <span
              >Parabéns! Você está em
              <strong>{{ contaAtual.posicao }}º</strong> no pódio</span
            >
          </div>
          <div v-else class="ranking-elos__minha-posicao">
            <i
              class="fas fa-ranking-star ranking-elos__minha-posicao-icone"
            ></i>
            <template v-if="contaAtual.posicao">
              <span class="ranking-elos__minha-posicao-texto"
                >Sua posição: <strong>{{ contaAtual.posicao }}º</strong></span
              >
              <span class="ranking-elos__minha-posicao-separador">•</span>
              <span class="ranking-elos__minha-posicao-pontos"
                >{{ contaAtual.pontuacao | formatacaoNumero }} pts</span
              >
            </template>
            <span v-else class="ranking-elos__minha-posicao-texto"
              >Pontuação insuficiente para o ranking</span
            >
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Tooltip from "./Tooltip.vue";
import Menu from "primevue/menu";

const NIVEL_INFO = {
  1: { classe: "ranking-item--ouro", icone: "fa-trophy" },
  2: { classe: "ranking-item--prata", icone: "fa-medal" },
  3: { classe: "ranking-item--bronze", icone: "fa-award" }
};

export default {
  name: "RankingElosDuradouros",
  components: {
    Tooltip,
    Menu
  },
  props: {
    carregando: {
      type: Boolean,
      required: true
    },
    dados: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selecionado: null,
      visible_menu_opcoes: false
    };
  },
  watch: {
    dados: {
      handler() {
        this.selecionarCategoria(this.label_botao_menu);
      },
      deep: true
    }
  },
  filters: {
    formatacaoNumero(value) {
      let valor = value;
      if (typeof value !== "number") {
        valor = parseInt(value);
      }
      return valor.toLocaleString("pt-BR");
    }
  },
  computed: {
    contaAtual() {
      if (!this.selecionado?.conta_atual) {
        return { conta_nome: "X", posicao: "X", pontuacao: "0" };
      }
      return this.selecionado.conta_atual;
    },
    // WEL-5193: só o pódio (top 3) — o restante de todas_contas não é
    // exibido no card compacto da Home.
    top3() {
      return this.selecionado?.todas_contas?.slice(0, 3) || [];
    },
    // WEL-5194: ordem VISUAL do pódio (2º, 1º, 3º) — o 1º ao centro.
    // A ordem de dados continua 1,2,3; só a exibição muda.
    podio() {
      const porPosicao = (p) => this.top3.find((d) => d.posicao === p);
      return [porPosicao(2), porPosicao(1), porPosicao(3)].filter(Boolean);
    },
    estaNoTop3() {
      return Boolean(this.contaAtual.posicao) && this.contaAtual.posicao <= 3;
    },
    label_botao_menu() {
      if (!Object.keys(this.dados).length) {
        return "Atende";
      }
      if (!this.selecionado) {
        return (
          Object.keys(this.dados)[0].charAt(0).toUpperCase() +
          Object.keys(this.dados)[0].slice(1)
        );
      }
      return this.selecionado.label;
    }
  },
  methods: {
    nivelClasse(posicao) {
      return NIVEL_INFO[posicao]?.classe || "";
    },
    nivelIcone(posicao) {
      return NIVEL_INFO[posicao]?.icone || "fa-award";
    },
    selecionarCategoria(categoria) {
      this.selecionado = this.dados[categoria.toLowerCase()];
      if (!this.selecionado) return;
      this.selecionado.label =
        categoria.charAt(0).toUpperCase() + categoria.slice(1);
      this.closeMenu();
    },
    closeMenu() {
      this.visible_menu_opcoes = false;
    },
    toggle() {
      this.visible_menu_opcoes = !this.visible_menu_opcoes;
    },
    timeline_filter_options() {
      return Object.keys(this.dados).map((key) => {
        return {
          label: key.charAt(0).toUpperCase() + key.slice(1),
          command: () => {
            this.selecionarCategoria(key);
          }
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// WEL-5194: pódio — degraus alinhados pela base, 1º ao centro e mais alto.
.podio {
  display: flex;
  align-items: flex-end;
  gap: 0.4rem;
}

.podio__lugar {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.podio__icone {
  font-size: 1.6rem !important;
  margin-bottom: 0.4rem;
}

.podio__degrau {
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.3rem;
  height: 46px;
  padding: 0 0.4rem;
  border-radius: 8px 8px 0 0;
  border-top: 2px solid transparent;
}

.podio__posicao {
  font-weight: 800;
  font-size: 1.3rem;
  line-height: 46px;
}

.podio__pontos {
  font-size: 0.78rem;
  font-weight: 600;
  color: #7c7c8a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

// O 1º lugar (centro) tem degrau e ícone maiores.
.ranking-item--ouro {
  .podio__icone {
    font-size: 2.1rem !important;
    color: #f5a000 !important;
  }

  .podio__degrau {
    height: 60px;
    background: #fff7e0;
    border-top-color: #f5a000;
  }

  .podio__posicao {
    color: #b57400;
    font-size: 1.5rem;
    line-height: 60px;
  }
}

.ranking-item--prata {
  .podio__icone {
    color: #9ca3af !important;
  }

  .podio__degrau {
    background: #f8fafc;
    border-top-color: #cbd5e1;
  }

  .podio__posicao {
    color: #6b7280;
  }
}

.ranking-item--bronze {
  .podio__icone {
    color: #c66a2b !important;
  }

  .podio__degrau {
    background: #fff3e8;
    border-top-color: #d98a52;
  }

  .podio__posicao {
    color: #a8551f;
  }
}

// Conta logada no pódio: contorno na cor do nível, sem mudar a altura.
.podio__lugar--propria .podio__degrau {
  box-shadow: inset 0 0 0 2px currentColor;
}

.ranking-item--ouro.podio__lugar--propria .podio__degrau {
  color: #f5a000;
}

.ranking-item--prata.podio__lugar--propria .podio__degrau {
  color: #9ca3af;
}

.ranking-item--bronze.podio__lugar--propria .podio__degrau {
  color: #c66a2b;
}

.ranking-elos__minha-posicao {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.85rem;
  border-radius: 10px;
  background: #f5f3fb;
  border: 1px solid #d9d2ef;
}

.ranking-elos__minha-posicao-icone {
  color: #472282 !important;
}

.ranking-elos__minha-posicao-texto {
  color: #472282;
  font-size: 0.88rem;
  font-weight: 600;
}

.ranking-elos__minha-posicao-separador {
  color: #a99fd0;
}

.ranking-elos__minha-posicao-pontos {
  color: #472282;
  font-weight: 700;
  font-size: 0.88rem;
}

.ranking-elos__parabens {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 0.85rem;
  border-radius: 10px;
  background: #e9f9ef;
  border: 1px solid #b7e4c7;
  color: #1e7e46;
  font-size: 0.88rem;
  font-weight: 600;

  i {
    color: #1e7e46 !important;
    font-size: 1.15rem !important;
  }
}
</style>
